/**
 * @description: Google reCAPTCHA Service.
 *
 * @requires   {Object} applicationModel
 * @requires   {Object} $rootScope
 * @requires   {Object} $window
 */
function googleRecaptchaService(applicationModel, $rootScope, $window) {

  let widgetId = null;
  let isInitialised = false;

  /**
   * @description Check if the Google reCAPTCHA Widget is initialised or not.
   */
  const widgetIsInitialised = () => isInitialised;

  /**
   * @description Reset the reCAPTCHA widget.
   * @returns {Boolean} True if widget was reset, false otherwise.
   */
  const resetCaptcha = () => {

    if (widgetIsInitialised()) {

      $window.grecaptcha.reset(widgetId);
      return true;

    }

    return false;

  };

  /**
   * @description Callback triggered when the reCAPTCHA challenge has passed.
   * We emit the event googleRecaptchaTokenAvailable with the Google reCAPTCHA
   * Token as a parameter to allow other components to catch the event via:
   * $rootScope.$on('googleRecaptchaTokenAvailable', token);
   * @param {String} token A google Recaptcha token generated.
   */
  const captchaCallback = (token) => {

    resetCaptcha();
    $rootScope.$emit('googleRecaptchaTokenAvailable', token);

  };

  /**
   * @description Renders the container as a reCAPTCHA widget and returns the ID of the newly created widget.
   * @param {String} container The HTML element to render the reCAPTCHA widget.
   * Specify either the ID of the container (string) or the DOM element itself.
   * @param {String} sitekey A google reCAPTCHA sitekey to use.
   * @returns {Number} The reCAPTCHA widget id (from 0 to n) or false if there was an issue.
   * @throws Error if unable to initialise the reCAPTCHA widget.
   */
  const initialiseCaptcha = (container, sitekey) => {

    try {

      widgetId = $window.grecaptcha.render(container, {
        sitekey: sitekey,
        callback: captchaCallback
      }, true);

      if (widgetId >= 0) {

        isInitialised = true;

        // Emit when widget is ready and is URL Request.
        if (applicationModel.stopUrlRequest === false) {

          applicationModel.stopUrlRequest = true;

          $rootScope.$emit('googleRecaptchaWidgetAvailable');

        }

        return widgetId;

      }

    } catch (err) {

      throw err;

    }

    return false;

  };

  /**
   * @description Programatically invoke the reCAPTCHA check.
   * @returns {Boolean} True if widget was invoked, false instead.
   */
  const invokeCaptcha = () => {

    if (widgetIsInitialised()) {

      $window.grecaptcha.execute(widgetId);
      return true;

    }

    return false;

  };

  return {
    widgetIsInitialised,
    resetCaptcha,
    captchaCallback,
    initialiseCaptcha,
    invokeCaptcha
  };

}

export default googleRecaptchaService;



// WEBPACK FOOTER //
// ./src/components/googlerecaptcha/google-recaptcha.service.js